<div class="aca-admin aca-wmset" [class.aca-wmset--embedded]="embedded">
  <p class="aca-set__cardnote">{{ 'DMS.WATERMARK.INTRO' | translate }}</p>

  <div class="aca-wmset__grid">
    <!-- ── the form ─────────────────────────────────────────────────────── -->
    <div class="aca-wmset__form">
      <div class="aca-set__row">
        <span class="aca-set__rowlabel">
          {{ 'DMS.WATERMARK.ENABLED' | translate }}
          <span class="aca-set__rowhint">{{ 'DMS.WATERMARK.ENABLED_HINT' | translate }}</span>
        </span>
        <mat-slide-toggle
          [checked]="draft().enabled"
          (change)="patch({ enabled: $event.checked })"
          [attr.aria-label]="'DMS.WATERMARK.ENABLED' | translate"
        />
      </div>

      <ng-container *ngIf="draft().enabled">
        <div class="aca-wmset__field">
          <label class="aca-set__rowlabel" for="aca-wmset-text">
            {{ 'DMS.WATERMARK.TEXT' | translate }}
          </label>
          <input
            id="aca-wmset-text"
            class="aca-set__input aca-wmset__text"
            type="text"
            maxlength="200"
            [ngModel]="draft().text"
            (ngModelChange)="patch({ text: $event })"
          />
          <p class="aca-set__hint aca-wmset__vars">
            <code>{{ '{{userName}}' }}</code> <code>{{ '{{userEmail}}' }}</code> <code>{{ '{{dateTime}}' }}</code>
            <code>{{ '{{docName}}' }}</code>
            — {{ 'DMS.WATERMARK.TEXT_HINT' | translate }}
          </p>
        </div>

        <div class="aca-wmset__field">
          <span class="aca-set__rowlabel">{{ 'DMS.WATERMARK.LOGO' | translate }}</span>
          <div class="aca-wmset__logorow">
            <img *ngIf="draft().logo" class="aca-set__logo" [src]="draft().logo" [alt]="'DMS.WATERMARK.LOGO' | translate" />
            <span class="aca-wmset__nologo" *ngIf="!draft().logo">{{ 'DMS.WATERMARK.NO_LOGO' | translate }}</span>
          </div>
          <div class="aca-set__logoactions">
            <input
              #logoInput
              type="file"
              class="aca-set__file"
              accept="image/png,image/jpeg,image/svg+xml,image/webp"
              (change)="pickLogo($event)"
              [attr.aria-label]="'DMS.WATERMARK.LOGO_PICK' | translate"
            />
            <button type="button" class="aca-set__outline" (click)="logoInput.click()">
              <mat-icon>image</mat-icon>{{ 'DMS.WATERMARK.LOGO_PICK' | translate }}
            </button>
            <button type="button" class="aca-set__linkbtn" *ngIf="draft().logo" (click)="removeLogo()">
              {{ 'DMS.WATERMARK.LOGO_REMOVE' | translate }}
            </button>
          </div>

          <div class="aca-wmset__slider aca-wmset__logosize" *ngIf="draft().logo">
            <label class="aca-set__rowhint aca-wmset__sliderlabel" for="aca-wmset-logosize">
              {{ 'DMS.WATERMARK.LOGO_SIZE' | translate }}
            </label>
            <input
              id="aca-wmset-logosize"
              type="range"
              [min]="limits.logoScaleMin"
              [max]="limits.logoScaleMax"
              step="5"
              [ngModel]="draft().logoScale"
              (ngModelChange)="patch({ logoScale: $event })"
            />
            <code>{{ draft().logoScale }}%</code>
          </div>
        </div>

        <div class="aca-wmset__field">
          <span class="aca-set__rowlabel">{{ 'DMS.WATERMARK.COLOR' | translate }}</span>
          <div class="aca-set__swatches">
            <button
              type="button"
              class="aca-set__swatchbtn"
              *ngFor="let preset of colourPresets"
              [class.aca-set__swatchbtn--on]="draft().color === preset"
              [style.background]="preset"
              [attr.aria-label]="preset"
              [attr.aria-pressed]="draft().color === preset"
              (click)="patch({ color: preset })"
            ></button>
          </div>
          <label class="aca-set__colourpick">
            <input
              type="color"
              [ngModel]="draft().color"
              (ngModelChange)="patch({ color: $event })"
              [attr.aria-label]="'DMS.WATERMARK.COLOR' | translate"
            />
            <span>{{ 'DMS.WATERMARK.COLOR_PICK' | translate }}</span>
            <code>{{ draft().color }}</code>
          </label>
        </div>

        <div class="aca-wmset__field">
          <label class="aca-set__rowlabel" for="aca-wmset-opacity">
            {{ 'DMS.WATERMARK.OPACITY' | translate }}
            <span class="aca-set__rowhint">{{ 'DMS.WATERMARK.OPACITY_HINT' | translate }}</span>
          </label>
          <div class="aca-wmset__slider">
            <input
              id="aca-wmset-opacity"
              type="range"
              [min]="limits.opacityMin"
              [max]="limits.opacityMax"
              step="0.01"
              [ngModel]="draft().opacity"
              (ngModelChange)="patch({ opacity: $event })"
            />
            <code>{{ opacityLabel }}</code>
          </div>
        </div>

        <div class="aca-wmset__pair">
          <div class="aca-wmset__field">
            <label class="aca-set__rowlabel" for="aca-wmset-size">{{ 'DMS.WATERMARK.SIZE' | translate }}</label>
            <div class="aca-wmset__slider">
              <input
                id="aca-wmset-size"
                type="range"
                [min]="limits.fontMin"
                [max]="limits.fontMax"
                step="1"
                [ngModel]="draft().fontSize"
                (ngModelChange)="patch({ fontSize: $event })"
              />
              <code>{{ draft().fontSize }}px</code>
            </div>
          </div>

          <div class="aca-wmset__field">
            <label class="aca-set__rowlabel" for="aca-wmset-rot">{{ 'DMS.WATERMARK.ROTATION' | translate }}</label>
            <div class="aca-wmset__slider">
              <input
                id="aca-wmset-rot"
                type="range"
                min="-90"
                max="90"
                step="5"
                [ngModel]="draft().rotation"
                (ngModelChange)="patch({ rotation: $event })"
              />
              <code>{{ draft().rotation }}°</code>
            </div>
          </div>
        </div>

        <div class="aca-wmset__field">
          <label class="aca-set__rowlabel" for="aca-wmset-layout">
            {{ 'DMS.WATERMARK.LAYOUT' | translate }}
            <span class="aca-set__rowhint">{{ 'DMS.WATERMARK.LAYOUT_HINT' | translate }}</span>
          </label>
          <select
            id="aca-wmset-layout"
            class="aca-set__select"
            [ngModel]="draft().layout"
            (ngModelChange)="patch({ layout: $event })"
          >
            <option value="tiled">{{ 'DMS.WATERMARK.LAYOUT_TILED' | translate }}</option>
            <option value="center">{{ 'DMS.WATERMARK.LAYOUT_CENTER' | translate }}</option>
          </select>
        </div>

        <div class="aca-set__row">
          <span class="aca-set__rowlabel">
            {{ 'DMS.WATERMARK.PRINT' | translate }}
            <span class="aca-set__rowhint">{{ 'DMS.WATERMARK.PRINT_HINT' | translate }}</span>
          </span>
          <mat-slide-toggle
            [checked]="draft().print"
            (change)="patch({ print: $event.checked })"
            [attr.aria-label]="'DMS.WATERMARK.PRINT' | translate"
          />
        </div>
      </ng-container>
    </div>

    <!-- ── live preview on a mock page ──────────────────────────────────── -->
    <div class="aca-wmset__side">
      <div class="aca-wmset__page">
        <span class="aca-wmset__line" *ngFor="let line of previewLines"></span>
        <app-watermark-overlay *ngIf="draft().enabled" [draft]="draft()" [docName]="sampleDoc" [at]="sampleTime" />
      </div>
      <p class="aca-set__hint">{{ 'DMS.WATERMARK.PREVIEW_HINT' | translate }}</p>
    </div>
  </div>

  <div class="aca-set__actions">
    <button type="button" class="aca-set__linkbtn aca-wmset__reset" [disabled]="busy()" (click)="reset()">
      {{ 'DMS.WATERMARK.RESET' | translate }}
    </button>
    <button type="button" class="aca-set__save" [disabled]="busy()" (click)="save()">
      {{ 'DMS.WATERMARK.SAVE' | translate }}
    </button>
  </div>
</div>
